__turbopack_context__.v({
  "contact-form": "contact-form-module-scss-module__h5MaLq__contact-form",
  "error": "contact-form-module-scss-module__h5MaLq__error",
  "success": "contact-form-module-scss-module__h5MaLq__success",
});
